document.addEventListener('DOMContentLoaded', function () {
    const filterForms = document.querySelectorAll('.custom-filter-form');

    // Dynamically set the selected style based on URL
    const currentUrl = window.location.pathname;
    const styleSelect = document.querySelector('#style');
    if (styleSelect) {
        const collectionHandle = currentUrl.split('/collections/')[1]?.split('?')[0] || 'all';
        styleSelect.value = collectionHandle;
    }

    filterForms.forEach(function (filterForm) {
        filterForm.addEventListener('submit', function (e) {
            e.preventDefault();
            const bedroomSelect = filterForm.querySelector('#bedrooms');
            const bathroomSelect = filterForm.querySelector('#bathrooms');
            const storiesSelect = filterForm.querySelector('#stories');
            const sqftMin = filterForm.querySelector('#sq-ft-min');
            const sqftMax = filterForm.querySelector('#sq-ft-max');
            const maxWidth = filterForm.querySelector('#max-width');
            const maxDepth = filterForm.querySelector('#max-depth');
            const styleSelect = filterForm.querySelector('#style');

            const searchParams = new URLSearchParams();

            if (bedroomSelect && bedroomSelect.value) {
                searchParams.append('filter.p.tag', bedroomSelect.value);
            }

            if (bathroomSelect && bathroomSelect.value) {
                const bathValue = bathroomSelect.value.replace(/-/g, '.');
                searchParams.append('filter.p.tag', bathValue);
            }

            if (storiesSelect && storiesSelect.value) {
                const storyValue = storiesSelect.value.replace(/-/g, '.');
                searchParams.append('filter.p.tag', storyValue);
            }

            if (sqftMin && sqftMin.value) {
                searchParams.append('filter.p.sqft_min', sqftMin.value);
            }

            if (sqftMax && sqftMax.value) {
                searchParams.append('filter.p.sqft_max', sqftMax.value);
            }

            if (maxWidth && maxWidth.value) {
                searchParams.append('filter.p.max_width', maxWidth.value);
            }

            if (maxDepth && maxDepth.value) {
                searchParams.append('filter.p.max_depth', maxDepth.value);
            }

            let baseUrl = '/collections/all';
            if (styleSelect && styleSelect.value && styleSelect.value !== 'all') {
                baseUrl = `/collections/${styleSelect.value}`;
            }

            window.location.href = `${baseUrl}?${searchParams.toString()}`;
        });
    });

    // Existing load-more logic
    const urlParams = new URLSearchParams(window.location.search);
    const hasFilters =
        urlParams.has('filter.p.tag') ||
        urlParams.has('filter.p.sqft_min') ||
        urlParams.has('filter.p.sqft_max') ||
        urlParams.has('filter.p.max_width') ||
        urlParams.has('filter.p.max_depth')
       

    if (hasFilters) {
        console.log('Filters detected:', urlParams.toString());
        const loadMoreElement = document.querySelector('load-more');
        if (loadMoreElement) {
            console.log('Load More Element found');
            loadMoreElement.isLastPage = false;
            loadMoreElement.setAttribute('page-url', window.location.href);
            loadMoreElement.addEventListener('load', function () {
                console.log('Load more triggered');
               
            });
        } else {
            console.log('Load More Element not found');
        }
      
        document.dispatchEvent(new CustomEvent('load-all-filtered-results'));
    }
});
